import { MoveRight, ShoppingCart, Tag } from 'lucide-react'
import Card from '../../../../components/common/Card'
import DOMPurify from 'dompurify'
import DefaultTable from '../../../../components/tables/DefaultTable/DefaultTable'
import { CompanyDetailType, useCompany } from '../../../../context/CompanyContext'

const Business = () => {
    const { detail } = useCompany()
    if (!detail) return null
    const business = detail.business

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'step',
            label: 'Fase'
        }
    ]

    const formattedBusiness = business.map((item: CompanyDetailType['business'][number]) => {
        return {
            ...item,
            step: (
                <div className='space-y-2'>
                    <div className='flex items-center gap-2' style={{ color: item.color }}>
                        <div className='w-[10px] h-[10px] rounded-full' style={{ backgroundColor: item.color }} />
                        <p className='font-bold text-sm'>{item.pipeline}</p>
                        <div>
                            <MoveRight className='w-5 h-5' />
                        </div>
                        <p className='font-bold text-sm'>{item.step}</p>
                    </div>
                    <div className='flex items-center gap-3 opacity-80'>
                        {/* Products */}
                        {item.products.length > 0 && (
                            <div className='flex items-center gap-1'>
                                <ShoppingCart className='w-4 h-4 text-brand-400' />
                                {item.products.map(
                                    (product: CompanyDetailType['business'][number]['products'][number]) => {
                                        return (
                                            <div className='border border-gray-200 dark:border-gray-600 py-1 px-2 rounded-lg'>
                                                <p>{product.name}</p>
                                            </div>
                                        )
                                    }
                                )}
                            </div>
                        )}
                        {/* Targets */}
                        {item.targets.length > 0 && (
                            <div className='flex items-center gap-1'>
                                <Tag className='w-4 h-4' />
                                {item.targets.map(
                                    (target: CompanyDetailType['business'][number]['targets'][number]) => {
                                        return (
                                            <div
                                                className='border py-1 px-2 rounded-lg'
                                                style={{
                                                    borderColor: target.color,
                                                    color: target.color
                                                }}
                                            >
                                                <p>{target.name}</p>
                                            </div>
                                        )
                                    }
                                )}
                            </div>
                        )}
                    </div>

                    <p
                        className='text-sm line-clamp-3 opacity-80'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description || '') }}
                    />
                </div>
            )
        }
    })

    const handleClick = (row: any) => {}

    return (
        <Card>
            <h2 className='font-bold text-base mb-4'>Negócios da empresa</h2>
            <DefaultTable columns={columns} rows={formattedBusiness} rowsPerPage={20} handleClick={handleClick} />
        </Card>
    )
}

export default Business
